import React, { useCallback } from 'react';
import { Search } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useCommandMenuToggle } from './AdminCommandMenu.callbacks';
import { setNextOpenTrigger } from './AdminCommandMenu.utils';
import { SearchButtonRoot } from './CommandMenuSearchButton.styles';

export const CommandMenuSearchButton: React.FC = () => {
  const toggle = useCommandMenuToggle();
  const { tq } = useTranslation('commandPaletteAdmin');

  const handleClick = useCallback(() => {
    setNextOpenTrigger('button');
    toggle?.();
  }, [toggle]);

  if (!toggle) return null;

  return (
    <SearchButtonRoot
      type="button"
      onClick={handleClick}
      aria-label={tq`Search pages and actions`}
    >
      <Search size="sm" />
    </SearchButtonRoot>
  );
};

CommandMenuSearchButton.displayName = 'CommandMenuSearchButton';
